import { GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { TYPE_ISSUE } from '~/issues/constants';
import UncollapsedAssigneeList from './uncollapsed_assignee_list.vue?vue3';
export default {
    name: 'IssuableAssignees',
    components: {
        GlButton,
        UncollapsedAssigneeList
    },
    props: {
        users: {
            type: Array,
            required: true
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_ISSUE
        },
        signedIn: {
            type: Boolean,
            required: false,
            default: false
        },
        editable: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'assign-self'
    ],
    computed: {
        emptyUsers () {
            return this.users.length === 0;
        }
    }
};
